import { browser } from "$app/environment";
import { getContext, setContext } from "svelte";


const CONTEXT = Symbol("SCROLL")

export function createScrollContext(): ScrollTracker {
  return setContext(CONTEXT, new ScrollTracker());
}

export function getScrollContext(): ScrollTracker {
  return getContext(CONTEXT)
}
   
export class ScrollTracker {
	scrollX = $state(0)
	scrollY = $state(0)

	scrollXPerc = $state(0)
	scrollYPerc = $state(0)

	positionX = 0
	positionY = 0
	
	_tracking = false

	constructor() {
		return this
	}

	init() {
		console.log("init scroll tracking")
		this._tracking = true
		this.track()
	}


	destroy() {
		this._tracking = false
	}


	track() {

		if( document.documentElement.scrollTop != this.positionY ) {
			this.positionY = document.documentElement.scrollTop
			this.scrollY = this.positionY
		}

		if( document.documentElement.scrollLeft != this.positionX ) {
			this.positionX = document.documentElement.scrollLeft
			this.scrollX = this.positionX
		}

		const diff = document.documentElement.scrollHeight-document.documentElement.clientHeight
		if( diff != 0) {
			this.scrollYPerc = document.documentElement.scrollTop / (diff) * 100
		}
		else {
			this.scrollYPerc = 100
		}

		if( this._tracking ) {
			requestAnimationFrame( () => this.track() )
		}
	
	}

	get Obj() {
		return {
			X: this.scrollX,
			Y: this.scrollY,
		}
	}

	get X() {
		return this.scrollX
	}

	get Y() {
		return this.scrollY
	}
}